/* @deprecated not used — voucher flux (actions/effects/hook) removed; schema kept to avoid RxDB migration */
export const vouchersSchema = {
	title: 'vouchers schema',
	version: 1,
	primaryKey: 'voucherCode',
	type: 'object',
	properties: {
		voucherCode: {
			type: 'string',
			maxLength: 300,
		},
		longDescription: {
			type: 'string',
		},
		shortDescription: {
			type: 'string',
		},
	},
	required: ['voucherCode'],
};
